define(['app/helpers/validator'], function (Validator) {
    function FormHandler(url) {
        var publics = {};
        var privates = {};

        publics.data = {};
        publics.data.fields = {};

        //publics.fieldAttributes = {};
        publics.data.url = false;
        publics.data.postSuccess = false;
        publics.data.postData = {};
        privates.validator = false;
        privates.ractiveInstance = false;

        privates.init = function () {
            publics.url = url || false;
            privates.validator = new Validator();
        };

        publics.validate = function () {
            var valid = true;

            $.each(publics.data.fields, function (fieldname, val) {
                valid = privates.validateField(fieldname, val.value) && valid;
            });

            publics.data.fields = publics.data.fields;

            return valid;
        };

        privates.validateField = function (fieldname, val) {
            var valid = privates.validator.validate(fieldname, val);
            publics.data.fields[fieldname].validated = true;
            publics.data.fields[fieldname].error = !valid;
            publics.data.fields = publics.data.fields;

            return valid;
        };

        publics.disable = function (field) {
            if (field) {
                publics.data.fields[field].disabled = true;
            } else {
                $.each(publics.data.fields, function (fieldname, value) {
                    publics.data.fields[fieldname].disabled = true;
                });
            }

            publics.data.fields = publics.data.fields;
        };

        publics.enable = function (field) {
            if (field) {
                publics.data.fields[field].disabled = false;
            } else {
                $.each(publics.data.fields, function (fieldname, value) {
                    publics.data.fields[fieldname].disabled = false;
                });
            }

            publics.data.fields = publics.data.fields;
        };

        publics.flagSuccess = function () {
            publics.data.postSuccess = true;
        };

        publics.setRactive = function (ractiveInstance) {
            privates.ractiveInstance = ractiveInstance;

            privates.ractiveInstance.on('inputBlur', function (event, hej) {
                var el = $(event.node);
                var value = el.val() || '';
                var fieldname = el.attr('id');

                if (fieldname) {
                    privates.validateField(fieldname, value);
                }
            });

            privates.ractiveInstance.observe(
                'fields.*.value',
                function (newValue, oldValue, keypath, field) {
                    if (publics.data.fields[field].error) {
                        privates.validateField(field, newValue);
                    }
                }
            );
        };

        publics.post = function (onSuccess, onError, url, requestMethod) {
            url = url || publics.data.url;
            requestMethod = requestMethod || 'POST';

            if (!publics.validate()) {
                if (_.isFunction(onError)) {
                    onError();
                }

                partyking.common.models.messages.warning(
                    'inline',
                    'Formuläret är inte rätt ifyllt'
                );
                return false;
            }

            if (!url) {
                if (_.isFunction(onError)) {
                    onError();
                }

                return false;
            }

            var fieldDataToPost = _.mapObject(
                publics.data.fields,
                function (val, key) {
                    return val.value;
                }
            );

            var postData = $.extend({}, publics.data.postData, fieldDataToPost);

            $.ajax({
                method: requestMethod,
                url: url,
                data: postData,
            })
                .done(function (data) {
                    if (_.isFunction(onSuccess)) {
                        onSuccess(data, postData);
                    }
                })
                .fail(function () {
                    if (_.isFunction(onError)) {
                        onError(err);
                    }
                });
        };

        privates.init();

        return publics;
    }

    return FormHandler;
});
